import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'trimToLength'
})
export class TrimToLengthPipe implements PipeTransform {
  transform(value: string, maxLength: number = 20, appendEllipsis: boolean = true): string {
    if (!value) {
      return '';
    }

    if (value.length <= maxLength) {
      return value;
    }

    const trimmedString = value.substring(0, maxLength);
    return appendEllipsis ? trimmedString + '...' : trimmedString;
  }
}
